import { DiContainer } from '@jack-henry/frontend-utils/di';
import { defaultDialogOptions } from '@treasury/domain-components/identity-verification-dialog/identity-verification-dialog.helpers';
import { SecurityMessage } from '@treasury/domain/channel/mappings/security';
import { IdentityDialogOptions, IdentityDialogResult, TmApiError } from '@treasury/domain/shared';
import { html } from 'lit';
import type { OmegaDialogService } from '../../services/omega-dialog';
import { type OmegaIdentityVerificationDialog } from './omega-identity-verification-dialog';

import { TmDialogService } from '@treasury/presentation/services/dialog';
import './omega-identity-verification-dialog';

/**
 * Opens the identity verification dialog with the given security message and options using Omega dialog.
 */
export async function openIdentityDialogLegacy<T = object>(
    securityMessage: SecurityMessage,
    options: Partial<IdentityDialogOptions> = {}
): Promise<IdentityDialogResult<T>> {
    const { forLogin, withoutUserInteraction, otpRequestFn, disableClose } = {
        ...defaultDialogOptions,
        ...options,
    };
    const diContainer = await DiContainer.getInstance();
    const dialogService = diContainer.get(TmDialogService) as OmegaDialogService;
    const result = dialogService.open<IdentityDialogResult<T>>(
        html`<omega-identity-verification-dialog
            .securityMessage=${securityMessage}
            .disableClose=${disableClose}
            .forLogin=${forLogin}
            .withoutUserInteraction=${withoutUserInteraction}
            .otpRequestFn=${otpRequestFn}
        ></omega-identity-verification-dialog>`,
        'Identity Verification',
        {
            // component renders its own buttons
            showButtons: false,
            preventClose: true,
        },
        {
            width: 400,
        }
    );

    const { reason, data } = await result;

    if (!data) {
        throw new Error('Identity dialog exited with no data.');
    }

    if (data instanceof TmApiError) {
        throw data;
    }

    const { response, message } = data;

    return {
        reason,
        response,
        message,
    };
}
